
<modal :index="index" :prevent-esc="isSaving" :should-cancel-on="!isSaving" :state="state" class="fds sm"
       @toggle-modal="reset"
>
  <h3 class="modal-title h3">Create new relationship</h3>
  <div class="modal-field">
    <label class="label-lg" for="relationship_label_title">{{ labelTitleDisplay }}</label>
    <input
      id="relationship_label_title"
      v-model="relationData.label_title"
      v-focus
      :disabled="isSaving"
      :placeholder="labelTitlePlaceholder"
      :readonly="isSaving"
      class="field_with_errors"
      type="text"
      @focus="currentlyActiveField = 'labelTitle'"
      @keyup.enter="create"
    />
    <template v-if="isInverseLabelable">
      <p class="text-grey">{{ relationTypeFriendlyName }}</p>
      <label class="label-lg" for="relationship_inverse_label_title">
        Role of Related Object Model(s)
      </label>
      <input
        id="relationship_inverse_label_title"
        v-model="relationData.inverse_label_title"
        :disabled="isSaving"
        :readonly="isSaving"
        class="field_with_errors"
        placeholder="Enter role of related object model(s)"
        type="text"
        @focus="currentlyActiveField = 'inverseLabelTitle'"
        @keyup.enter="create"
      />
    </template>
    <label class="label-lg" for="relationship_reference_name">
      Reference name
    </label>
    <input
      id="relationship_reference_name"
      v-model="relationData.reference_name"
      :disabled="isSaving"
      :placeholder="`Enter reference name`"
      :readonly="isSaving"
      class="field_with_errors"
      type="text"
      @focus="currentlyActiveField = 'referenceName'"
      @keyup.enter="create"
    />
  </div>

  <div v-if="isReferenceNamePresent && !isReferenceNameValid" class="error-text">Not a unique reference name.</div>
  <div class="cta">
    <button :disabled="isSaving" class="btn red outline block" type="button" @click="reset">Cancel</button>
    <button :disabled="!isValid || isSaving" class="btn green block" type="button" @click="create">
      Create
    </button>
  </div>
</modal>
